const equalHeight = (items, applyto) => {

    if (jQuery(items).length < 1) { return false; }


    let $items = jQuery(items);

    $items.attr("style", 0);

    let results = $items.map((i, item) => jQuery(item).outerHeight());

    let highest = Math.max.apply(null, results);


    setTimeout(() => { (typeof applyto !== "undefined" ? jQuery(applyto).css("height", highest) : jQuery(items).css("height", highest)), 500 });

};

const adjustHeights = throttle(() => {

    setTimeout(() => {

        equalHeight(".industry-item .content");

    }, 300);

}, 200);